let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("deThS")).then(() => parcelRequire('d7TUP'));